import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { AppBar } from './AppBar';

export function MainLayout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          width: '100vw',
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 1600,
            px: { xs: 2, md: 4, lg: 6 },
            py: 3,
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
